export default __webpack_public_path__ + "static/fa-regular-400-1a3b38ded5527fe7130fdfb12e1625ea.woff2";